import React from 'react';
import { CheckCircle2 } from 'lucide-react';
export function Pricing() {
  return <section className="pt-48 pb-32 px-6" data-id="element-446">
      <div className="max-w-7xl mx-auto text-center" data-id="element-447">
        <h2 className="font-['Archivo_Black'] text-4xl md:text-6xl uppercase mb-16" data-id="element-448">
          Simple Pricing
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-449">
          {[{
          name: 'Launch Page',
          price: '49',
          features: ['Link Hub', '1 Page', 'Basic Analytics']
        }, {
          name: 'Creator Pro',
          price: '149',
          features: ['5 Pages', 'SEO', 'Media Vault'],
          popular: true
        }, {
          name: 'Enterprise',
          price: '499',
          features: ['Streaming', 'Press Kits', 'Priority Support']
        }].map((tier, i) => <div key={i} className={`p-10 rounded-2xl border ${tier.popular ? 'bg-[#1A1A1A] border-[#FFD700]' : 'bg-black/40 border-white/5'}`} data-id="element-450">
              <h3 className="font-['Archivo_Black'] text-2xl uppercase mb-4" data-id="element-451">
                {tier.name}
              </h3>
              <div className="text-4xl font-['Archivo_Black'] mb-8" data-id="element-452">
                ${tier.price}
                <span className="text-sm text-gray-500" data-id="element-453">/mo</span>
              </div>
              <ul className="space-y-4 mb-10 text-left" data-id="element-454">
                {tier.features.map((f, j) => <li key={j} className="flex items-center gap-3 text-sm" data-id="element-455">
                    <CheckCircle2 size={16} className="text-[#FFD700]" data-id="element-456" /> {f}
                  </li>)}
              </ul>
              <button className={`w-full py-4 rounded font-bold uppercase tracking-widest ${tier.popular ? 'bg-[#FFD700] text-black' : 'bg-white/5 border border-white/10'}`} data-id="element-457">
                Select Plan
              </button>
            </div>)}
        </div>
      </div>
    </section>;
}